import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { compact, flatten, zipWith, groupBy } from 'lodash-es'
import { envUrls, envName } from '../../data/objects/env'

const getRecentDealsXDays = () => {
  let lastXDays: number
  switch (envName) {
    case 'development':
      lastXDays = 2000
      break
    case 'qa':
    case 'demo':
    case 'london':
      lastXDays = 150
      break
    default:
      lastXDays = 7 // default for production
  }
  return lastXDays
}
const fakeNames = [
  'Ashlyn',
  'Ryleigh',
  'Karli',
  'Tom',
  'Virginia',
  'Arabella',
  'Mercedes',
  'Malia',
  'Patience',
  'Chana',
  'Mylie',
  'Adam',
  'Taryn',
  'Veronica',
  'Kasey',
  'Joe',
  'Kirsten',
  'Jaycee',
  'Raina',
  'Josh',
  'Maria',
  'Alice',
  'Lucy',
  'Shiloh',
  'Joanna',
  'Alicia',
  'Joan',
  'Ashley',
  'Steven',
  'Gloria',
  'Jacquelyn',
  'Rob',
  'Norah',
  'Clare',
  'Lainey',
]
enum DealItemType {
  ring = 'ring',
  bracelet = 'bracelet',
  earrings = 'earrings',
  necklace = 'necklace',
  watch = 'watch',
}

export interface RecentDeal {
  itemDescription: string
  imageSmall: string
  imageLarge: string
  imageMobile: string
  interested: number
  price: string
  when: string
  dealUrl: string
  sellerName: string
  itemType: DealItemType
}

type RecentDeals = RecentDeal[]
interface ApiResponseStructure {
  name: string
  item_image_featured: string
  item_image_full_size: string
  item_image_featured_small: string
  item_image_featured_large: string
  item_image_featured_mobile: string
  item_image_large_wide: string
  bids: number
  amount: string
  item_deal_url: string
  time_ago: string
  fe_index: number
  item_type: string
}
const recentDealsTransform = (apiRes: any): RecentDealsState => {
  let transformed: RecentDeals = []

  if (apiRes) {
    transformed = apiRes.items.idp.map((itemData: ApiResponseStructure) => ({
      itemDescription: itemData.name,
      sellerName: fakeNames[itemData.fe_index % fakeNames.length],
      imageSmall: itemData.item_image_featured_small || itemData.item_image_featured || itemData.item_image_full_size,
      imageLarge: itemData.item_image_featured_large || itemData.item_image_large_wide || itemData.item_image_full_size,
      imageMobile:
        itemData.item_image_featured_mobile ||
        itemData.item_image_featured ||
        itemData.item_image_large_wide ||
        itemData.item_image_full_size,
      interested: itemData.bids,
      price: itemData.amount,
      when: itemData.time_ago,
      dealUrl: itemData.item_deal_url,
      itemType: itemData.item_type,
    }))
  }
  return {
    deals: compact(flatten(zipWith(...Object.values(groupBy(transformed, 'itemType'))))),
  }
}

export interface RecentDealsState {
  deals: RecentDeals
}

// Define a service using a base URL and expected endpoints
export const RecentDealsApi = createApi({
  reducerPath: 'recentDealsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: envUrls.contentBE,
  }),
  endpoints: (builder) => ({
    getRecentDeals: builder.query<RecentDealsState, void>({
      keepUnusedDataFor: 3600,
      query: () => ({
        url: `getRecentDeals?${['Rings', 'Watches', 'Bracelets', 'Necklaces', 'Earrings']
          .map((type) => `item_types[]=${type}`)
          .join('&')}`,
        params: {
          count: 25,
          last_x_days: getRecentDealsXDays(),
        },
      }),
      transformResponse: recentDealsTransform,
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetRecentDealsQuery } = RecentDealsApi
